import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle } from "lucide-react";
import { WA_DEFAULT, bookingHref } from "@/lib/site";

export const CtaBand = ({ service, title = "Parkurda buluşalım.", text = "Tarihini seç, talebini gönder. Uygunluğu teyit edip sana dönelim." }) => (
  <section data-testid="cta-band" className="bg-brand">
    <div className="mx-auto flex max-w-7xl flex-col justify-between gap-8 px-5 py-16 md:flex-row md:items-center md:px-8 md:py-20">
      <div>
        <h2 className="font-display text-5xl uppercase leading-none text-white md:text-6xl">{title}</h2>
        <p className="mt-3 max-w-xl text-white/90">{text}</p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Link to={bookingHref(service)} data-testid="cta-booking-btn" className="group flex items-center justify-center gap-3 bg-black px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-black">
          Rezervasyon yap <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
        <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn" className="flex items-center justify-center gap-3 border border-white px-8 py-4 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">
          <MessageCircle className="h-5 w-5" /> WhatsApp
        </a>
      </div>
    </div>
  </section>
);
